import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import {
  createUserThunk,
  fetchUsersThunk,
  updateUserThunk,
} from './services/usersThunks';

const initialState: UsersState = {
  users: { apiStatus: APIStatus.IDLE, result: null, error: undefined },
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersThunk.pending, (state) => {
        state.users.apiStatus = APIStatus.PENDING;
        state.users.error = undefined;
      })
      .addCase(fetchUsersThunk.fulfilled, (state, action: PayloadAction<Users>) => {
        state.users.apiStatus = APIStatus.IDLE;
        state.users.result = action.payload;
        state.users.error = undefined;
      })
      .addCase(fetchUsersThunk.rejected, (state, action) => {
        state.users.apiStatus = APIStatus.PENDING;
        state.users.error = action.error;
      });
    builder
      .addCase(createUserThunk.pending, (state) => {
        state.users.apiStatus = APIStatus.PENDING;
        state.users.error = undefined;
      })
      .addCase(createUserThunk.fulfilled, (state, action: PayloadAction<IUser>) => {
        state.users.apiStatus = APIStatus.IDLE;
        state.users.result = state.users.result
          ? state.users.result.concat(action.payload)
          : [action.payload];

        state.users.error = undefined;
      })
      .addCase(createUserThunk.rejected, (state, action) => {
        state.users.apiStatus = APIStatus.REJECTED;
        state.users.error = action.error;
      });
    builder
      .addCase(updateUserThunk.pending, (state) => {
        state.users.apiStatus = APIStatus.PENDING;
        state.users.error = undefined;
      })
      .addCase(updateUserThunk.fulfilled, (state, action: PayloadAction<IUser>) => {
        state.users.apiStatus = APIStatus.IDLE;
        state.users.result =
          state.users.result?.map((m) =>
            m.idIri === action.payload.idIri ? action.payload : m,
          ) ?? null;

        state.users.error = undefined;
      })
      .addCase(updateUserThunk.rejected, (state, action) => {
        state.users.apiStatus = APIStatus.REJECTED;
        state.users.error = action.error;
      });
  },
});

export default usersSlice.reducer;
export const usersActions = usersSlice.actions;
export const getUsersState = (state: RootState) => state.users;
